import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import DealComponent from './Deal';
import {ApiBaseUrl} from '../../../constants';
import { AuthContext } from "./../../../context/auth";
import { Link } from "react-router-dom";
import { trackPromise } from 'react-promise-tracker';
import {withSnackbar} from "react-simple-snackbar";

class ViewAllDeals extends Component{
    static contextType = AuthContext;
    state = {
        hasMoreItems: true,
        page: 1,
        deals: []
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(nextState.page !== this.state.page)
            return true;
        else
            return false;
    }

    loadItems(page) {
        page=this.state.page;
        var url = ApiBaseUrl+'/consumer/allday/shared_deals?page='+page;

        trackPromise(
        fetch(url,{
            method: 'GET',
            headers:
                {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Authorization": "Bearer "+this.context.token
                }
        })
            .then(res => res.json())
            .then(
                (result) => {
                    result.data.data.map(category => (
                        this.state.deals.push(category)
                    ));

                    if(result.data.data.length > 0) {
                        document.getElementById('body').className='shared-deals pagi-page'
                        this.setState({hasMoreItems: true, page: this.state.page+1})
                    }
                    else
                        this.setState({hasMoreItems: false})
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        hasMoreItems: false,
                    });
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        document.getElementById('body').className='shared-deals'
    }
    componentWillUnmount () {
        document.getElementById('body').className=''
    }

    render(){
        let deals = [];
        let msg = null;
        if(this.state.deals.length===0) {
            msg = (<div className="col-12 text-center text-white">
                You don't have any deals yet.<br/>Per Person Deals shared by associate host will be added here.
            </div>)
        }
        this.state.deals.map( deal => (
            deals.push(
                <DealComponent key={deal._id} data={deal} />
            )
        ));

        return(
            <React.Fragment>
                <div className="overlay">
                </div>
            <div className="choose-deals-outer p-l-0 p-r-0">
                <div className="container">
                    <div className="row">
                        <div className="deals-tab-outer font-0 outer-glow1 mb-4 mx-auto px--xs-0">
                            <Link to={`${process.env.PUBLIC_URL}/allday/shared-deals`}
                                  className="tabing-text grad-on">Per
                                Person Deals</Link>
                            <Link to={`${process.env.PUBLIC_URL}/oneday/shared-deals`} className="tabing-text">Group
                                Deals</Link>
                        </div>
                        {msg}
                        <InfiniteScroll
                            pageStart={1}
                            loadMore={this.loadItems.bind(this)}
                            hasMore={this.state.hasMoreItems}
                            className="associatehost-outer pt-0 pb-0 px--xs-0"
                        >
                            {deals}
                        </InfiniteScroll>
                    </div>
                </div>
            </div>
            </React.Fragment>
        )
    }
}

export default withSnackbar(ViewAllDeals,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});